// DomImage
import React from 'react';

export default class DomImage extends React.Component {
  render() {
    const src = this.props.src ? this.props.src : '';
    const alt = this.props.alt ? this.props.alt : '';
    const className = this.props.className ? this.props.className : '';

    return ( <img src={src} alt={alt} className={className} /> );
  }
};



// WEBPACK FOOTER //
// ./src/components/DomImage.jsx